<template>
  <div class="cas">
    <div class="view" style="margin-top: 20px">
      <v-carousel
        cycle
        hide-delimiters
        show-arrows-on-hover
        class="carousel-pc carousel"
      >
        <v-carousel-item v-for="(item, i) in img" :key="i">
          <div class="img" :style="getImg(item)"></div>
        </v-carousel-item>
      </v-carousel>
      <v-carousel
        cycle
        hide-delimiters
        show-arrows-on-hover
        class="carousel-mobile carousel"
        height="200"
      >
        <v-carousel-item v-for="(item, i) in img" :key="i">
          <div class="img" :style="getImg(item)"></div>
        </v-carousel-item>
      </v-carousel>
      <div class="right">
        <div>
          <p class="app-info-app">{{ $t("i18n.cas.content") }}</p>
        </div>
        <div class="div-btn">
          <!-- <img src="../assets/images/cas-logo.png" class="logo" /> -->
          <a
            href="http://47.111.119.228:8000" 
            class="btn-android"
            style="text-decoration: none"
            target="_blank"
          >
            <span>{{ $t("i18n.cas.link") }}</span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data: () => {
    return {
      img: [
        require("../assets/images/apps/cas1.png"),
        require("../assets/images/apps/cas2.png"),
      ],
    };
  },
  methods: {
    getImg(img) {
      return `background-image: url('${img}');`;
    },
  },
};
</script>

<style scoped>
.cas {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media only screen and (min-width: 600px) {
  .view {
    width: 80%;
    display: inline-flex;
    flex-direction: row;
    margin: 50px 0px;
    justify-content: space-between;
    align-content: flex-start;
  }
  .img {
    width: 100%;
    height: 100%;
    background-size: 100%;
    background-position: top center;
    background-blend-mode: normal;
    background-repeat: no-repeat;
  }
  .right {
    width: 40%;
    text-align: left;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .left {
    width: 60%;
    text-align: left;
    display: inline-flex;
    flex-direction: column;
  }
  .div-btn {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .btn-android {
    width: 300px;
    height: 60px;
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgb(2,159,232);
    color: #fff;
  }
  .btn-android:hover {
    box-shadow: 1px #f5f5f5;
    box-shadow: 0px 1px 10px rgb(2,159,232);
    color: #fff;
  }
  .carousel {
    text-align: center;
    width: 60%;
  }
  .carousel-mobile {
    display: none !important;
  }
  .span {
    font-weight: bold;
    font-size: 40px;
  }
  .span-content {
    font-size: 25px;
  }
  .span-ver {
    font-size: 10px;
  }
  .logo {
    height: 80px;
    margin-bottom: 20px;
  }
  .app-info {
    display: none;
  }
  .app-info-app{
    text-indent: 2em;
    font-weight: bold;
    color: rgb(2,159,232);
    font-size: 20px;
    margin: 40px 20px;
  }
}
@media only screen and (max-width: 600px) {
  .view {
    width: 90%;
    display: inline-flex;
    flex-direction: row;
    margin-top: 80px;
    justify-content: space-between;
    align-content: flex-start;
  }
  .img {
    width: 100%;
    height: 100%;
    background-size: 100%;
    background-position: top center;
    background-blend-mode: normal;
    background-repeat: no-repeat;
  }
  .right {
    width: 50%;
    text-align: left;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 4px;
  }
  .left {
    width: 50%;
    text-align: left;
    display: inline-flex;
    flex-direction: column;
  }
  
  .carousel {
    text-align: center;
    width: 60%;
  }
  .carousel-pc {
    display: none !important;
  }
  .div-btn {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .btn-android {
    width: 90%;
    height: 40px;
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgb(2,159,232);
    color: #fff;
    font-size: 15px;
  }
  .span {
    font-weight: bold;
    font-size: 20px;
  }
  .span-content {
    font-size: 15px;
  }
  .span-ver {
    font-size: 10px;
  }
  .logo {
    height: 80px;
    margin-bottom: 10px;
  }
  .app-info {
    color: rgb(2,159,232);
    font-size: 16px;
    font-weight: 600;
    text-indent: 2em;
    
  }
  .app-info-app{
    display: none;
  }
}
</style>
